import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'
import { ProductTypeToggleGroup } from '@features/products/elements/ProductTypeToggleGroup'

import { useFormContext } from '../../../../../../../../../../../../hooks'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'

export const DefaultProductType = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { FormItem } = useFormContext<InvoiceSettingsFormSchema>()

  return (
    <FormItem
      label={t('settings.organization.external_invoice.general.default_product_type.label')}
      name="productType"
      render={({ field: { onChange, value } }) => {
        return (
          <ProductTypeToggleGroup
            onChange={(event) => {
              onChange(event)
              trackInvoicingSettings('Default Item Type toggled', {
                type: event.target.value,
              })
            }}
            value={value}
            withLabels
          />
        )
      }}
    />
  )
}
